import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";

export function useMyProperties() {
  return useQuery({
    queryKey: ["my-properties"],
    queryFn: async () => (await api.get("/properties")).data,
  });
}

export function usePrimaryPropertyId() {
  const { data, isLoading } = useMyProperties();
  return { propertyId: data && data.length ? data[0].id : null, isLoading, properties: data || [] };
}
